module.exports = __webpack_public_path__ + "static/media/screenshot.d924b2a2.svg";